import { useCallback, useState } from "react";
import { IFileMappingByClient } from "src/app/shared/models/fileMappingSetup.model";
import { STATUS_CODES } from 'src/app/shared/constants/common.constants'
import { getListFileMappingFormatsByClients } from "src/app/shared/services/ClientSetupService";

export interface IFileMappingByClientTab {
  fileMappingByClient: any
  isGettingFileMappingByClient: boolean
  getFileMappingByClientList: (payload: Partial<any>) => Promise<void>,
}

export const useFileMappingByClient = (): IFileMappingByClientTab => {
  const [fileMappingByClient, setFileMappingByClient] = useState<IFileMappingByClient[]>([]);
  const [isGettingFileMappingByClient, setIsGettingFileMappingByClient] = useState<boolean>(false);

  const getFileMappingByClientList = useCallback(async (payload: any) => {
    try {
      setIsGettingFileMappingByClient(true)
      const res: any = await getListFileMappingFormatsByClients(payload)
      if (res.statusCode === STATUS_CODES.SUCCESS) {
        setFileMappingByClient(res.data)
      }
    } catch (error) {
      console.log('ERROR: ', error)
    } finally {
      setIsGettingFileMappingByClient(false)
    }
  }, []);

  return {
    fileMappingByClient,
    isGettingFileMappingByClient,
    getFileMappingByClientList
  }
}